import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';

function MoneyTransfer() {
  const [query1, setQuery1] = useState("");
  const [suggestions1, setSuggestions1] = useState(false);
  const [userId1, setUserId1] = useState("");
  const [userFrom, setUserFrom] = useState(false);
  const [query2, setQuery2] = useState("");
  const [suggestions2, setSuggestions2] = useState(false);
  const [userId2, setUserId2] = useState("");
  const [userTo, setUserTo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [transfer, setTransfer] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { transferType, transferFrom, transferTo, amount, comments } = e.target;
      let requestData = {
        from: userId1,
        to: userId2,
        amount: amount.value,
        comments: comments.value
      };
      let url = transferType.value == "recharge" ? "/user/transfer/balance" : "/user/transfer/remit/balance";
      const response = await axios.post(url, requestData);
      const { status, message } = response.data;
      if (status) {
        toast(message);
        setTransfer(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getTransfer = (e) => {
    setTransfer({ ...transfer, [e.target.name]: (e.target.selectedIndex - 1) });
  };
  // const getData = async () => {
  //   try {
  //     const response = await axios.get("/get/all/users");
  //     const { status, users } = response.data;
  //     if (status) {
  //       setData(users);
  //     }
  //   } catch (error) {
  //     if (error?.response?.data?.message) {
  //       toast(error.response.data.message);
  //     }
  //   }
  // };
  useEffect(() => {
    //getData();
  }, []);

  useEffect(() => {
    if (query1.length < 2) {
      setSuggestions1(false);
      setUserId1("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query1)}`).then((res) => {
      setSuggestions1(res.data.users); // Adjust to your API response
      setLoading(false);
    }).catch(() => {
      setSuggestions1(false);
      setLoading(false);
    });
  }, [query1]);

  useEffect(() => {
    if (query2.length < 2) {
      setSuggestions2(false);
      setUserId2("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query2)}`).then((res) => {
      setSuggestions2(res.data.users); // Adjust to your API response
      setLoading(false);
    }).catch(() => {
      setSuggestions2(false);
      setLoading(false);
    });
  }, [query2]);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                Money Transfer
              </h4>
              <form className="searchForm" onSubmit={handleSubmit}>
                <div class="row">
                  <div class="col-lg-3 col-md-3">
                    <label for="transferType">Transfer Type</label>
                    <select class="form-control" name="transferType" required>
                      <option value="remitance">REMITANCE</option>
                      <option value="recharge">RECHARGE</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label for="transferFrom">Transfer From</label>
                    {/* <select class="form-control" name="transferFrom" onChange={getTransfer} required>
                      <option value="">--Select--</option>
                      {
                        data && data.map(user => (
                          <option value={user._id}>{user.name}</option>
                        ))
                      }
                    </select> */}
                    <input
                      type="text"
                      class="form-control"
                      value={query1}
                      onChange={(e) => setQuery1(e.target.value)}
                      placeholder="Type to search..."
                    />

                    {suggestions1 && suggestions1.length > 0 && (
                      <ul
                        style={{
                          border: "1px solid #ccc",
                          marginTop: 0,
                          paddingLeft: 0,
                          listStyleType: "none",
                          maxHeight: 150,
                          overflowY: "auto",
                          cursor: "pointer",
                        }}
                      >
                        {suggestions1.map((item, idx) => (
                          <li
                            key={idx}
                            style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                            onClick={() => {
                              setQuery1(item.name+"("+item.mobile+")"); // Adjust as per your data structure
                              setUserId1(item._id);
                              setUserFrom(item);
                              setSuggestions1(false);
                            }}
                          >
                            {item.name+"("+item.mobile+")"}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label for="transferTo">Transfer To</label>
                    {/* <select class="form-control" name="transferTo" onChange={getTransfer} required>
                      <option value="">--Select--</option>
                      {
                        data && data.map(user => (
                          <option value={user._id}>{user.name}</option>
                        ))
                      }
                    </select> */}
                    <input
                      type="text"
                      class="form-control"
                      value={query2}
                      onChange={(e) => setQuery2(e.target.value)}
                      placeholder="Type to search..."
                    />

                    {suggestions2 && suggestions2.length > 0 && (
                      <ul
                        style={{
                          border: "1px solid #ccc",
                          marginTop: 0,
                          paddingLeft: 0,
                          listStyleType: "none",
                          maxHeight: 150,
                          overflowY: "auto",
                          cursor: "pointer",
                        }}
                      >
                        {suggestions2.map((item, idx) => (
                          <li
                            key={idx}
                            style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                            onClick={() => {
                              setQuery2(item.name+"("+item.mobile+")"); // Adjust as per your data structure
                              setUserId2(item._id);
                              setUserTo(item);
                              setSuggestions2(false);
                            }}
                          >
                            {item.name+"("+item.mobile+")"}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label for="amount">Amount</label>
                    <input class="form-control" type="number" name="amount" required />
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <label for="status">Comments</label>
                    <textarea class="form-control" name="comments" required></textarea>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <input type="submit" className="search-btn btn btn-primary" value="Transfer Money" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  {userFrom && (
                    <>
                      <strong>Transfer From</strong>
                      <div className="col-lg-12 col-md-12">
                        {userFrom.name}
                      </div>
                      <div className="col-lg-12 col-md-12">
                        Mobile: {userFrom.mobile}
                      </div>
                      <div className="col-lg-12 col-md-12">
                        Wallet Balance: {userFrom.wallet_balance}
                      </div>
                      <div className="col-lg-12 col-md-12">
                        Remit Balance: {userFrom.remit_balance}
                      </div>
                    </>
                  )}
                </div>
                <div className="col-lg-6 col-md-6">
                  {userTo && (
                    <>
                      <strong>Transfer To</strong>
                      <div className="col-lg-12 col-md-12">
                        {userTo.name}
                      </div>
                      <div className="col-lg-12 col-md-12">
                        Mobile: {userTo.mobile}
                      </div>
                      <div className="col-lg-12 col-md-12">
                        Wallet Balance: {userTo.wallet_balance}
                      </div>
                      <div className="col-lg-12 col-md-12">
                        Remit Balance: {userTo.remit_balance}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MoneyTransfer;
